(() => {
  const initDirectory = (root) => {
    if (!root || root.dataset.rmxReady === 'true') return;
    root.dataset.rmxReady = 'true';

    const cards = Array.from(root.querySelectorAll('[data-rmx-directory-item]'));
    const letters = Array.from(root.querySelectorAll('[data-rmx-letter]'));
    const search = root.querySelector('[data-rmx-directory-search]');
    const empty = root.querySelector('[data-rmx-directory-empty]');
    const count = root.querySelector('[data-rmx-directory-count]');
    let activeLetter = 'all';

    const available = new Set(cards.map((card) => (card.dataset.rmxFirst || '').toUpperCase()).filter(Boolean));
    letters.forEach((button) => {
      const value = (button.dataset.rmxLetter || '').toUpperCase();
      button.disabled = value !== 'ALL' && !available.has(value);
    });

    const apply = () => {
      const query = search ? search.value.trim().toLowerCase() : '';
      let visible = 0;
      cards.forEach((card) => {
        const first = (card.dataset.rmxFirst || '').toLowerCase();
        const title = (card.dataset.rmxTitle || '').toLowerCase();
        const matchLetter = activeLetter === 'all' || first === activeLetter.toLowerCase();
        const matchSearch = !query || title.includes(query);
        card.hidden = !(matchLetter && matchSearch);
        if (!card.hidden) visible += 1;
      });
      if (empty) empty.hidden = visible > 0;
      if (count) count.textContent = `${visible} ${visible === 1 ? 'result' : 'results'}`;
    };

    letters.forEach((button) => button.addEventListener('click', () => {
      if (button.disabled) return;
      activeLetter = button.dataset.rmxLetter || 'all';
      letters.forEach((item) => item.classList.toggle('is-active', item === button));
      apply();
    }));

    if (search) search.addEventListener('input', () => {
      activeLetter = 'all';
      letters.forEach((item) => item.classList.toggle('is-active', (item.dataset.rmxLetter || '') === 'all'));
      apply();
    });

    const infoButtons = Array.from(root.querySelectorAll('[data-rmx-category-info]'));

    const closeTips = (except = null) => {
      infoButtons.forEach((button) => {
        if (button === except) return;
        button.classList.remove('is-open', 'is-flip', 'is-left', 'is-right');
        button.setAttribute('aria-expanded', 'false');
      });
    };

    const placeTip = (button) => {
      const tip = button.querySelector('.rmx-category-card__tip');
      if (!tip) return;

      button.classList.remove('is-flip', 'is-left', 'is-right');
      const buttonRect = button.getBoundingClientRect();
      const tipRect = tip.getBoundingClientRect();
      const predictedLeft = buttonRect.left + (buttonRect.width / 2) - (tipRect.width / 2);
      const predictedRight = predictedLeft + tipRect.width;

      if (buttonRect.bottom + 44 + tipRect.height > window.innerHeight - 10) button.classList.add('is-flip');
      if (predictedLeft < 10) button.classList.add('is-left');
      if (predictedRight > window.innerWidth - 10) button.classList.add('is-right');
    };

    infoButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const willOpen = !button.classList.contains('is-open');
        closeTips(button);
        button.classList.toggle('is-open', willOpen);
        button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) placeTip(button);
      });
      button.addEventListener('mouseenter', () => placeTip(button));
    });

    if (infoButtons.length) {
      root.addEventListener('click', (event) => {
        if (!event.target.closest('[data-rmx-category-info]')) closeTips();
      });
      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) closeTips();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeTips();
      });
      window.addEventListener('resize', () => {
        const openButton = infoButtons.find((button) => button.classList.contains('is-open'));
        if (openButton) placeTip(openButton);
      }, { passive: true });
    }

    apply();
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-rmx-directory-root]').forEach(initDirectory);
  };

  document.addEventListener('DOMContentLoaded', () => boot());
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
